import { useState, useSyncExternalStore } from 'react'
import { useCommonT } from '../../i18n'
import { applyUpdate, isUpdateReady, subscribeUpdateReady } from '../../lib/serviceWorker'

/**
 * "Update ready": a new build is installed and waiting (src/lib/serviceWorker.ts).
 * Tapping reloads this tab into it; "Later" hides the prompt for this page
 * load, and the browser switches builds by itself on the next cold start.
 * Never reloads on its own, so nobody loses a half-typed edit to a deploy.
 *
 * Rendered once by the app shell (App.tsx). Renders nothing until an update
 * is waiting, so the prerendered HTML and every test without a worker are
 * unchanged.
 */
export default function UpdateReadyPrompt() {
  const t = useCommonT()
  const ready = useSyncExternalStore(subscribeUpdateReady, isUpdateReady, () => false)
  const [dismissed, setDismissed] = useState(false)
  if (!ready || dismissed) return null
  return (
    <div
      role="status"
      data-testid="update-ready"
      className="fixed bottom-[calc(5rem+var(--ad-inset-bottom,0px))] left-1/2 -translate-x-1/2 md:bottom-[calc(1rem+var(--ad-inset-bottom,0px))] z-[95] flex items-center gap-3 px-4 py-2 rounded-full bg-gray-900/95 border border-gray-700 text-sm text-gray-100 shadow-lg"
    >
      <span>{t('sw_update.ready')}</span>
      <button type="button" onClick={applyUpdate} className="font-semibold text-blue-300 hover:text-white">
        {t('sw_update.apply')}
      </button>
      <button type="button" onClick={() => setDismissed(true)} className="text-gray-400 hover:text-white">
        {t('sw_update.later')}
      </button>
    </div>
  )
}
